import { render } from "./dashboardMenu.vue?vue&type=template&id=4720ef94"
import script from "./dashboardMenu.vue?vue&type=script&lang=js"
export * from "./dashboardMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__